/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { SyncStatus } from './sync-source-wrapper';

export class SyncStatusData {
  private _syncStatus: string;
  filteredReason?: string;
  errorMessage?: string;

  constructor(syncStatus: string, filteredReason?: string, errorMessage?: string) {
    this._syncStatus = syncStatus;
    this.filteredReason = filteredReason;
    this.errorMessage = errorMessage;
  }

  get syncStatus(): SyncStatus {
    switch (this._syncStatus) {
      case 'live':
        return SyncStatus.LIVE;
      case 'pending_verification':
        return SyncStatus.PENDING_VERIFICATION;
      case 'syncing':
        return SyncStatus.SYNCING;
      case 'synced':
        return SyncStatus.SYNCED;
      case 'error':
      case 'errored':
        return SyncStatus.ERROR;
      case 'filtered':
        return SyncStatus.FILTERED;
      case 'excluded':
        return SyncStatus.EXCLUDED;
      case 'deletion_in_progress':
        return SyncStatus.DELETION_IN_PROGRESS;
      default:
        return SyncStatus.ERROR;
    }
  }
}
